"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var useServerHeadInsertion_exports = {};
__export(useServerHeadInsertion_exports, {
  ServerRenderID: () => ServerRenderID,
  getServerHeadInsertions: () => getServerHeadInsertions,
  useServerHeadInsertion: () => useServerHeadInsertion
});
module.exports = __toCommonJS(useServerHeadInsertion_exports);
var import_react = require("react");
var ServerHeadInsertions = {};
var getServerHeadInsertions = function getServerHeadInsertions2(id) {
  if (ServerHeadInsertions[id]) {
    return Object.values(ServerHeadInsertions[id]);
  }
};
var ServerRenderID = /* @__PURE__ */ (0, import_react.createContext)("");
var useServerHeadInsertion = function useServerHeadInsertion2(callback) {
  if (typeof window == "undefined") {
    var _ServerHeadInsertions, _id;
    var insertionID = (0, import_react.useId)();
    var id = (0, import_react.useContext)(ServerRenderID);
    (_ServerHeadInsertions = ServerHeadInsertions)[_id = id] || (_ServerHeadInsertions[_id] = {});
    ServerHeadInsertions[id][insertionID] = callback;
  }
};
//# sourceMappingURL=useServerHeadInsertion.js.map
